import { getLang } from "@/i18n";

// Messaggi di errore dei moduli in italiano (il browser li mostra nella sua lingua, spesso inglese).
const MSG = {
  valueMissing: (el) => (el.type === "checkbox" ? "Spunta questa casella per continuare." : "Compila questo campo."),
  typeMismatch: (el) => (el.type === "email" ? "Inserisci un indirizzo email valido (es. nome@azienda.it)." : "Formato non valido."),
  tooShort: (el) => `Scrivi almeno ${el.minLength} caratteri.`,
  tooLong: (el) => `Massimo ${el.maxLength} caratteri.`,
  rangeUnderflow: (el) => `Il valore minimo è ${el.min}.`,
  rangeOverflow: (el) => `Il valore massimo è ${el.max}.`,
  stepMismatch: () => "Valore non valido.",
  patternMismatch: () => "Formato non valido.",
  badInput: () => "Valore non valido.",
};

export const installItalianValidation = () => {
  if (getLang() !== "it") return;
  document.addEventListener("invalid", (e) => {
    const el = e.target;
    if (!el?.validity || el.validity.customError) return;
    const k = Object.keys(MSG).find((x) => el.validity[x]);
    if (k) el.setCustomValidity(MSG[k](el));
  }, true);
  const clear = (e) => e.target?.setCustomValidity?.("");
  document.addEventListener("input", clear, true);
  document.addEventListener("change", clear, true);
};
